/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from 'react';
import { getAllowanceList } from 'api/attendAllowance';
import AttendAllowanceDomain from 'domain/master/labor/attendAllowance';

export const useAttendAllowanceList = () => {
  const [allowanceList, setAllowanceList] = useState<Array<AttendAllowanceDomain>>([]);
  useEffect(() => {
    getAllowanceList().then((response: Array<any>) => {
      setAllowanceList(response.map((result) => new AttendAllowanceDomain(result)));
    });
  }, []);
  return { allowanceList, setAllowanceList };
};

export default useAttendAllowanceList;
